import React from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { mdiRemoteTv } from "@mdi/js";
import Main from "../../components/layout/Main";
import RemoteCard from "./RemoteCard";
import { REMOTE_PATHS, placeOf } from "./remoteUtils";
import "../../assets/styles/app-remotes.css";

// The app's Select Device (app/screens/HashhRemote/SelectIRBM.js): the IR
// blaster a new remote is learned on, shown when the home has more than one.
// Each card has the blaster's name, device id and floor | room, like the app's
// RemoteCard. Location state: { blasters, categories, steps }.
function SelectBlaster() {
  const { state } = useLocation();
  const history = useHistory();

  if (!state?.blasters?.length) return <Redirect to={REMOTE_PATHS.UNIVERSAL} />;

  const choose = (blaster) =>
    history.push(REMOTE_PATHS.ADD_CATEGORY, { blaster, categories: state.categories, steps: state.steps + 1 });

  return (
    <Main header="stack" title="Select Device" hideTabBar>
      <ul className="hx-remote-cards">
        {state.blasters.map((blaster) => (
          <RemoteCard
            key={blaster.applianceId ?? blaster.deviceId}
            icon={mdiRemoteTv}
            name={blaster.name}
            accent={blaster.deviceId}
            meta={placeOf(blaster)}
            onOpen={() => choose(blaster)}
          />
        ))}
      </ul>
    </Main>
  );
}

export default SelectBlaster;
